import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const hasModuleTBAI = store.getters['auth/hasTBAIModule']
  const hasModuleReceivedInvoice = store.getters['auth/hasReceivedInvoiceModule']
  const hasModuleOCRIntegration = store.getters['auth/hasOCRIntegrationModule']
  const companiesMenu = {
    icon: 'companies',
    name: i18n.t('companies.header'),
    path: 'companies',
    use_parent_params: true,
    params_required: ['id'],
    registerNavFromMenu: false,
    sc: [
      {
        name: i18n.t('app.detail'),
        path: 'companies/detail',
        params,
        registerNavFromMenu: false,
        sc: [] // shorcuts
      },
      {
        name: i18n.t('companies.configuration.header'),
        path: 'companies/config',
        params,
        registerNavFromMenu: false,
        disabled: params.id === -1 || params.id === '-1',
        sc: [] // shorcuts
      },
      {
        name: i18n.t('companies.configuration_rec.dir_header'),
        path: 'companies/pgeconfig',
        params,
        registerNavFromMenu: false,
        disabled: params.id === -1 || params.id === '-1',
        sc: [] // shorcuts
      },
      {
        name: i18n.t('companies.configuration_aps.aps_header'),
        path: 'companies/apsconfig',
        params,
        registerNavFromMenu: false,
        disabled: params.id === -1 || params.id === '-1',
        sc: [] // shorcuts
      },
      {
        name: i18n.t('companies.configuration_tbai.tbaiconfig'),
        path: 'companies/tbaiconfig',
        params,
        registerNavFromMenu: false,
        disabled: params.id === -1 || params.id === '-1',
        sc: [] // shorcuts
      },
      {
        name: i18n.t('historical.entity_name'),
        path: 'companies/historical',
        params,
        registerNavFromMenu: false,
        disabled: params.id === -1 || params.id === '-1',
        sc: []
      }
    ]
  }
  
  if (!hasModuleReceivedInvoice) {
    // const index = companiesMenu.sc.findIndex(x => x.path.endsWith('pgeconfig'))
    // if (index > -1) companiesMenu.sc.splice(index, 1)
  }
  if (!hasModuleOCRIntegration) {
    const index = companiesMenu.sc.findIndex(x => x.path.endsWith('apsconfig'))
    if (index > -1) companiesMenu.sc.splice(index, 1)
  }
  if (!hasModuleTBAI) {
    const index = companiesMenu.sc.findIndex(x => x.path.endsWith('tbaiconfig'))
    if (index > -1) companiesMenu.sc.splice(index, 1)
  }
  return [
    companiesMenu
  ]
}
